import { AxiosResponse } from 'axios'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { ResponseGeneric } from 'utils/types'

import { RequestREAD, RequestCDU } from '../Instances'
import { DateTime } from 'services/database/reportsDatabase'
import { ISaveFileRequest } from './Contract'

const RecordsSheetServices = () => {
  const path = 'Bloqueio'
  const GetByFilters = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetByFilters`, {
      params: requestObj
    })

  const LiberarFRS = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/LiberarFRS`, requestObj)

  const BloquearFRS = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/BloquearFRS`, requestObj)

  const AlterarBloqueio = async (
    requestObj: IAlterarBloqueio
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/AlterarBloqueio`, requestObj)

  return { BloquearFRS, GetByFilters, LiberarFRS, AlterarBloqueio }
}

export interface IAlterarBloqueio {
  idBloqueio: number
  idMotivo: number
  txObservacao: string
  matriculaSolicitante: string
  nmSolicitante: string
  valorRisco: number
  processo: string
  idUsuario: number
  cdChamadoCervello: string
  listAnexarDocs?: ISaveFileRequest[]
  idFornecedorPrincipal: number
}

const RecordsSheetGetBlock = () => {
  const path = 'FolhaRegistro'
  const GetBloqueio = async (
    requestObj: IGetBloqueioRequest
  ): Promise<AxiosResponse<GetBloqueioResponseDTO>> =>
    await RequestREAD.get(`${path}/GetBloqueio`, {
      params: requestObj
    })

  const GetLiberacao = async (
    idBloqueio: number,
    cdContrato?: string,
    idFornecedor?: number,
    dataLiberacao?: DateTime,
    txNumeroDocumento?: string,
    flBuscarTodosContratos?: boolean,
    isFromMagnifyingGlass?: boolean
  ): Promise<AxiosResponse<GetLiberacaoResponseDTO>> =>
    await RequestREAD.get(`${path}/GetLiberacao`, {
      params: {
        idBloqueio: idBloqueio,
        DataLiberacao: dataLiberacao,
        ...(cdContrato ? { cdContrato: cdContrato } : {}),
        ...(idFornecedor ? { idFornecedor: idFornecedor } : {}),
        ...(txNumeroDocumento ? { txNumeroDocumento: txNumeroDocumento } : {}),
        flBuscarTodosContratos: flBuscarTodosContratos,
        isFromMagnifyingGlass: isFromMagnifyingGlass,
      }
    })

  const GetFornecedorByContract = async (
    requestObj: any
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetContratoById`, {
      params: requestObj
    })

  const PutBloquearFRSAP = async (
    idFolhaRegistro: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(
      `${path}/AlterarStatusSAP?idFolhaRegistro=${idFolhaRegistro}`,
      {}
    )

  return {
    GetBloqueio,
    GetFornecedorByContract,
    GetLiberacao,
    PutBloquearFRSAP
  }
}

const RecordSheetCRUDServices = () => {
  const path = 'FolhaRegistro'
  const GetFolhaRegistro = async (
    cdFolhaRegistro: string
  ): Promise<AxiosResponse<IGetRecordSheetResponse[]>> =>
    await RequestREAD.get(`${path}/BuscarPeloCodigo`, {
      params: { codigoFolhaRegistro: cdFolhaRegistro }
    })

  const CreateRecordSheet = async (
    requestObj: INewAndUpdateRecordSheet
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const UpdateRecordSheet = async (
    requestObj: INewAndUpdateRecordSheet
  ): Promise<AxiosResponse<ResponseGeneric>> =>
    await RequestCDU.put(`${path}/Update`, requestObj)

  const DeleteRecordSheet = async (
    idFolhaRegistro: number
  ): Promise<AxiosResponse<ResponseGeneric>> =>
    await RequestCDU.put(
      `${path}/Desativar?idFolhaRegistro=${idFolhaRegistro}`,
      {}
    )

  return {
    CreateRecordSheet,
    DeleteRecordSheet,
    GetFolhaRegistro,
    UpdateRecordSheet
  }
}
const ContractServices = () => {
  const path = 'Contrato'
  const GetContractByContrato = async (
    cd: string
  ): Promise<
    AxiosResponse<IGenericEntityResponse<ContratoAutocompleteResponseDTO[]>>
  > => await RequestREAD.get(`${path}/AutocompleteContrato/?cdContrato=${cd}`)

  return { GetContractByContrato }
}

const MotivoBloqueioServices = () => {
  const path = 'MotivoBloqueio'
  const GetALL = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/BuscarTodos`)
  const CreateMotivo = async (requestObj: any) =>
    await RequestCDU.post(`${path}/Create`, requestObj)
  const UpdateMotivo = async (requestObj: any) =>
    await RequestCDU.patch(`${path}/Update`, requestObj)
  const DeleteMotivo = async (id: number) =>
    await RequestCDU.delete(`${path}/Delete`, {
      params: {
        id: id
      }
    })
  const GetTipoMotivo = async (): Promise<
    AxiosResponse<ITipoMotivoBloqueio[]>
  > => await RequestREAD.get(`${path}/BuscarTiposMotivoBloqueio`)

  return { CreateMotivo, DeleteMotivo, GetALL, GetTipoMotivo, UpdateMotivo }
}

export {
  RecordsSheetServices,
  MotivoBloqueioServices,
  RecordsSheetGetBlock,
  RecordSheetCRUDServices,
  ContractServices
}

export interface ICentroPlanta {
  idCentroPlanta: number
  txDescricao: string
  empresaId?: string
  txCidd?: string
  txEndr?: string
  nuCnpj?: string
}

export interface MotivosBloqueioInterface {
  idMotivoBloqueio: number
  tipoMotivoBloqueioId: number
  txMotivo: string
  txDescricao: string
  txTipo: string
}

export interface IGetBloqueioRequest {
  cdContrato: string
  idFornecedor: number
  flBuscarTodosContratos: boolean
  idBloqueio?: number
  isFromMagnifyingGlass?: boolean // ← Novo campo
}

export interface FolhaRegistroResponseDTO {
  idFolhaRegistro: number
  idBloqueio: number
  nmCentroPlanta: string
  txNumeroDocumento: number
  dsTipoDocumento: string
  flBloqPagamento: boolean
  dsFormaPagamento: string
  idContrato: number
  txDescricao: string
  vlLiquido: number
  vlBruto: number
  txReferencia: string
  motivo: string
  dtVencimento: string
  cdFolhaRegistroSRV: string
  cdContrato: string
  flBloqueadoSAP: boolean
  flImportadoSAP: boolean
  txBloqueioPagamento: string
}

export interface GetBloqueioResponseDTO {
  vlRiscoPrevidenciario: number
  vlRiscoTrabalhista: number
  vlRiscoOutros: number
  vlTotal: number
  dataBloqueio: DateTime
  nmFornecedor: string
  statusFornecedor: string
  motivoBloqueioId: number
  matriculaSolicitante: string
  nomeSolicitante: string
  observacao: string
  valorRisco: number
  processo: string
  cdChamadoCervello: string
  folhasRegistro: FolhaRegistroResponseDTO[]
}

export interface GetLiberacaoResponseDTO {
  idBloqueioItem: number
  idFolhaRegistro: number
  idLiberacaoBloqueio: number
  idBloqueio: number
  vlRiscoPrevidenciario: number
  vlRiscoTrabalhista: number
  vlRiscoOutros: number
  vlTotal: number
  nmFornecedor: string
  observacoes: string
  statusFornecedor: string
  folhasRegistro: FolhaRegistroResponseDTO[]
}

export interface DadosContratoRequestDTO {
  cdContrato: string
  cdChamadoCervello: string | null
  idBloqueio?: number
}

export interface ITipoMotivoBloqueio {
  idTipoMotivoBloqueio: number
  txTipo: string
}

export interface INewAndUpdateRecordSheet {
  cdContrato: string
  cdFolhaRegistroSRV: string
  dsFormaPagamento: string
  dsTipoDocumento: string
  txNumeroDocumento: number
  txDocumento: string
  anoCompetencia: string
  numeroLinha: string
  contratoId: number
  dtVencimento: string
  cdDocumentoCompra: string
  flBloqPagamento: boolean
  FlArquivado: boolean
  vlLiquido: number
  txDescricao: string
  idFolhaRegistro: number
  nmCentroPlanta: string
}

export interface IGetRecordSheetResponse {
  anoCompetencia: string | null
  cdContrato: string
  cdFolhaRegistroSRV: string | null
  contratoId: number
  dsFormaPagamento: string
  dsTipoDocumento: string
  dtUltAtualizacaoSap: string | null
  dtVencimento: string
  flBloqPagamento: boolean | null
  flImportadoSAP: boolean | null
  flArquivado: boolean | null
  flLegado: boolean | null
  idFolhaRegistro: number
  nmCentroPlanta: string
  numeroLinha: string | null
  txDescricao: string
  txDocumento: string
  txNumeroDocumento: string
  vlLiquido: number
}

export interface ContratoAutocompleteResponseDTO {
  idContrato: number
  cdContrato: string
  fornecedorId: number
  cdDocto: string
  nmFornecedor: string
  empresaId: number
  txDescricaoEmpresa: string
  centroPlantaId: number
  txDescricaoCentroPlanta: string
}